import router from '@client-frontend/router'

export function getCustomerIdFromCurrentRoute(key = 'customer_id') {
	return router.currentRoute()?.params[key] ?? ''
}
